<template>
    <!-- PRODUCT-26110 Task 5 (INSTANCE_ATTRS_CLASS_STYLE): see CriterionEnumInput.vue --
         inheritAttrs: false stops Vue 3 from auto-applying class/style to root; FormElement
         has normal (default) inheritAttrs, so binding them here still reaches its own root. -->
    <FormElement
        class="CriterionCheckboxInput"
        :class="$attrs.class"
        :style="$attrs.style"
        :required="required"
    >
        <template #requiredIndicator>
            {{ translate('requiredLabel') }}
        </template>

        <FormInput :invalid="accessed && hasError">
            <div :id="id" class="CriterionCheckboxInput__checkBox">
                <Checkbox
                    :model-value="value"
                    :disabled="disabled || rbacDisabled"
                    @update:model-value="onInput"
                >
                    {{ customTitle || form.schema.title || '' }}
                </Checkbox>
            </div>
            <template v-if="deletable && !rbacDisabled" #actionButtons>
                <NewButton
                    variant="flat"
                    size="icon-sm"
                    color="secondary"
                    class="JsonSchemaForm__deleteIcon"
                    @click="$emit('delete')"
                >
                    <EidIcon :icon-src="faXmark" alt="delete" />
                </NewButton>
            </template>
        </FormInput>

        <template v-if="accessed && error" #errorMessage>
            {{ error }}
        </template>
    </FormElement>
</template>

<script lang="ts">
    import { Component } from '@evidentid/vue-property-decorator';

    import { faXmark } from '@fortawesome/pro-light-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import { Checkbox } from '@evidentid/dashboard-commons/components/Checkbox';
    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import { FormElement, FormInput } from '@evidentid/dashboard-commons/components/Form';
    import AbstractJsonSchemaForm
        from '@evidentid/dashboard-commons/components/JsonSchemaForm/elements/AbstractJsonSchemaForm';
    import LockInputIcon from '@evidentid/dashboard-commons/components/LockInputIcon/LockInputIcon.vue';
    import { JsonFormBase } from '@evidentid/json-schema/interfaces/JsonForm';
    import { JsonSchemaBoolean } from '@evidentid/json-schema/interfaces/JsonSchema';

    import NewButton from '@/components/new-button/NewButton.vue';

    type JsonFormBoolean = JsonFormBase<JsonSchemaBoolean>;

    @Component({
        emits: [ 'delete', 'input' ],
        components: { FormInput, FormElement, Checkbox, FontAwesomeIcon, LockInputIcon, NewButton, EidIcon },
        inheritAttrs: false,
    })
    export default class CriterionCheckboxInput extends AbstractJsonSchemaForm<JsonFormBoolean, boolean> {
        private faXmark = faXmark;

        private onInput(value: boolean) {
            this.touch();
            this.$emit('input', this.form.getValue(value));
        }
    }
</script>
